import { Component, OnInit } from '@angular/core';
import { BoltMenuItem } from '../../bolt-menu-item.model';
import { BoltSidenavService } from '../../bolt-sidenav.service';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UserDataService } from 'src/app/shared/services/user-data.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  currentURL!: any;
  menuItem: BoltMenuItem | undefined;
  panelOpenState = false;
  userUID: string | undefined;
  personalInfo: any;
  constructor(
    public afAuth: AngularFireAuth,
    private layoutService: BoltSidenavService,
    private router: Router,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private firestore: AngularFirestore,
    private userDataService: UserDataService
  ) {
    // this.currentURL = this.route?['_routerState']?['snapshot']?['url']
    this.userUID = this.userDataService.userUID;
  }

  ngOnInit(): void {
    this.getPersonalInfo();
    this.layoutService.emitMenuOptions.subscribe((item: any) => {
      setTimeout(() => {
        const route = (this.route as any)._routerState;
        this.currentURL = route.snapshot.url;
        if (item && item.length > 0) {
          item.forEach((element: any) => {
            const route = element?.route?.substring(1);
            if (this.currentURL?.includes(route)) {
              this.menuItem = element;
            } else if (element.children && element.children.length > 0) {
              element.children.forEach((child: any) => {
                const route = child?.route?.substring(1);
                if (this.currentURL?.includes(route)) {
                  this.menuItem = child;
                }
              });
            }
          });
        } else this.menuItem = item;
      }, 50);
    });
  }

  getPersonalInfo() {
    this.firestore
      .collection('clientProfile')
      .doc(this.userUID)
      .get()
      .subscribe((data: any) => {
        let obj = data.data();
        obj.firstName = obj?.firstName + ' ' + obj?.lastName;
        this.personalInfo = obj;
      });
  }

  logout(): void {
    this.afAuth
      .signOut()
      .then(() => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: 'You are successfully logged out.',
            type: 'success',
          },
        });
        sessionStorage.removeItem('userUID');
        this.router.navigate(['/login']);
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
      });
  }
}
